import { render, staticRenderFns } from "./overall-status.vue?vue&type=template&id=08a963b2&scoped=true&"
import script from "./overall-status.vue?vue&type=script&lang=js&"
export * from "./overall-status.vue?vue&type=script&lang=js&"
import style0 from "./overall-status.vue?vue&type=style&index=0&id=08a963b2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a963b2",
  null
  
)

export default component.exports